import { axiosTemplate } from '../../axiosTemplate';
export const platformFileUpload = {
    endpoints: {
        test: `https://y2rq4731g7.execute-api.us-east-1.amazonaws.com/test`,
        acceptance: `https://zr0gum642h.execute-api.us-east-1.amazonaws.com/acceptance`,
        prod: `https://f2bbdjrfmj.execute-api.us-east-1.amazonaws.com/prod`,
    },
    http: {
        imageUpload: ({ data, stage, token, cancelToken }) => {
            return axiosTemplate(token, cancelToken).post(`${platformFileUpload.endpoints[stage]}/images`, data);
        },
    },
};
